import { Component } from '@angular/core';

@Component({
  template: '<h1>404 Page Not Found</h1>'
})

export class NotFoundComponent {

}
